// extracted by mini-css-extract-plugin
module.exports = {"root":"T9chSZcSHEmzR21yKqSD","linkButton":"Tvv850SbG1NogKVSjvMA","errorBody":"yeqx7IcCcUThdXHMkO6i","headline":"sBugrwsx3Mr98xZJ66D5"};